/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="97.38"
        height="95.59"
        viewBox="0 0 97.38 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M83 3a1.25 1.25 0 0 1 1.24 1.12v34.15a1.25 1.25 0 0 1-1.25 1.25 1.27 1.27 0 0 1-1.25-1.13V5.51H71.1v10a1.25 1.25 0 0 1-1.12 1.24h-.08a1.26 1.26 0 0 1-1.25-1.12V4.27a1.24 1.24 0 0 1 1.12-1.26ZM14.35 24a1.24 1.24 0 0 1 1.24 1.12v52.82h25.59A1.27 1.27 0 0 1 42.43 79v.13a1.25 1.25 0 0 1-1.12 1.24h-27a1.25 1.25 0 0 1-1.24-1.13v-54A1.26 1.26 0 0 1 14.35 24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M47.95.27a1.24 1.24 0 0 1 1.3-.07l.12.07 47.41 32.46a1.252 1.252 0 1 1-1.3 2.14l-.12-.07-46.7-32-46.7 32a1.25 1.25 0 0 1-1.66-.22l-.08-.11a1.24 1.24 0 0 1 .22-1.65l.1-.09ZM66.9 37.2c-6.08 5.45-13.38 8.18-22.49 8.45a1.25 1.25 0 0 0-1.22 1.25v9.18c0 9.37 1 16.15 3.87 22.27 3.64 7.77 10.15 13.53 20.25 17.16a1.24 1.24 0 0 0 .85 0c10.09-3.63 16.6-9.39 20.25-17.16 2.87-6.12 3.86-12.89 3.86-22.27V46.9a1.24 1.24 0 0 0-1.21-1.25c-9.15-.27-16.41-3-22.49-8.45a1.24 1.24 0 0 0-1.67 0Zm.83 2.58.41.34a35.58 35.58 0 0 0 21 7.94h.59v8c0 9-.94 15.49-3.63 21.21l-.19.4c-3.26 6.69-8.88 11.72-17.57 15.07l-.65.24.43.16c-9.49-3.41-15.48-8.71-18.84-15.87l-.2-.44c-2.53-5.61-3.43-12-3.43-20.77v-8h.59c8.31-.54 15.19-3.13 21-7.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m78.24 56.75 2.12 2.12-15.38 15.4-9.91-9.91 2.12-2.12 7.79 7.79 13.26-13.26Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'HouseWithCheckmarkShieldIcon';

export default Icon;
